import { render, staticRenderFns } from "./ControlsContainer.vue?vue&type=template&id=6fbaeeb8&scoped=true"
import script from "./ControlsContainer.vue?vue&type=script&lang=ts"
export * from "./ControlsContainer.vue?vue&type=script&lang=ts"
import style0 from "./ControlsContainer.vue?vue&type=style&index=0&id=6fbaeeb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fbaeeb8",
  null
  
)

export default component.exports